module.exports = __webpack_public_path__ + "assets/img/chronicleImgActive-67a6590d.png";